import { render } from "./PostCardCase.vue?vue&type=template&id=19f1efd8"
import script from "./PostCardCase.vue?vue&type=script&lang=js"
export * from "./PostCardCase.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/derolfgroep-ict/derolfgroep-ict/web/app/themes/rolfhardware/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__